import React, { useEffect, useState } from 'react';
import { useFilterContext } from "../../contexts/FilterContext";

const CheckboxFilter = ({ options, getOptions, className, title }) => {
    const { name, filterValue, setFilterValue, updateURLParams } = useFilterContext();

    const [loadedOptions, setLoadedOptions] = useState(options || []);

    useEffect(() => {
        const fetchOptions = async () => {
            if (getOptions) {
                const result = await getOptions();
                setLoadedOptions(result);
            }
        };
        fetchOptions();
    }, [getOptions]);

    useEffect(() => {
        if (filterValue) {
            updateURLParams(name, filterValue);
        }
    }, [filterValue]);

    const handleChange = (e) => {
        const value = e.target.value;
        const isChecked = e.target.checked;
        setFilterValue((prevStatus) => {
                if(!Array.isArray(prevStatus)){
                    prevStatus = [];
                }
                return isChecked ? [...prevStatus, value] : prevStatus.filter((status) => status !== value)
            }
        );
    };

    return (
        <div className={`filter ${className}`}>
            {title && <div className="mb-1">{title}</div>}
            {loadedOptions.map((option) => (
                <div className="checkbox-small" key={option.value}>
                    <input
                        type="checkbox"
                        name={option.value}
                        value={option.value}
                        id={option.value}
                        checked={filterValue.includes(option.value)}
                        onChange={handleChange}
                    />
                    <label htmlFor={option.value}>{option.label}</label>
                </div>
            ))}
        </div>
    );
};

export default CheckboxFilter;
